<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Components</span>
        <h3 class="page-title">Article</h3>
      </div>
    </div>

    <div class="category py-3">
      <d-row class="pl-3">
        <d-col>
        <label class="d-block">Selected category: </label>
        <select class="badge badge-outline-secondary badge-pill" @change="changeCategories($event), select($event.target.value)">
          <option value="" selected disabled>Choose</option>
          <option
            v-for="category in categories"
            :value="category.id"
            :key="category.id"
          >
            {{ category.name }}
          </option>
        </select>
        </d-col>
        <d-col>
          <p align="right">
            <d-button outline v-on:click="redirectUser()">Add News</d-button>
          </p>
        </d-col>
      </d-row>

    </div>

    <!-- First Row of Posts -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Article</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Title</th>
                  <th scope="col" class="border-0">Author</th>
                  <th scope="col" class="border-0">Created date</th>
                  <th scope="col" class="border-0">Visibility</th>
                  <th scope="col" class="border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="result in Article" :key="result.id">
                  <td>{{ result.title }}</td>
                  <td>{{ result.authorName }}</td>
                  <td>{{ result.postTime }}</td>
                  <td>
                    <i v-if="result.published" class="material-icons mr-1"
                      >visibility</i
                    >
                    <i v-else class="material-icons mr-1">visibility_off</i>
                  </td>
                  <td>
                    <d-button-group size="small">
                      <d-button
                        class="btn btn-white btn-primary"
                        v-on:click="modify(result.id, result.published)"
                        ><i class="material-icons">edit</i></d-button
                      >
                      <d-button
                        class="btn btn-danger"
                        v-on:click="deleteData(result.id)"
                        ><i class="material-icons">delete</i></d-button
                      >
                    </d-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </d-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      initLang: {
        title: "en",
        flag: "gb"
      },
      options: [
        {
          title: "en",
          flag: "gb"
        },
        {
          title: "zt",
          flag: "hk"
        },
        {
          title: "zc",
          flag: "cn"
        }
      ],
      Article: [],
      categories: [],
      selectedCategory: null,
    };
  },
  mounted: function () {
    this.onpageload();
  },
  methods: {
    onChange(lang) {
    },
    async onpageload() {
      await axios
        .get(process.env.VUE_APP_API+"api/staff/Category")
        .then((response) => {
          this.categories = response.data.result.result;
        })
        .catch(function (error) {
          console.log(error);
        });
      await axios
        .get(process.env.VUE_APP_API+"api/staff/Article")
        .then((response) => {
          this.Article = response.data.result.result;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    redirectUser() {
      if (1 == 1) {
        this.$router.push({
          name: "add-new-post",
          params: { pageTitle: "Create New Article", creating:true },
        });
      }
    },
    modify(id, published) {
      if (id != null) {
        this.$router.push({
          name: "update-post",
          params: { id: id, pageTitle: "Update Article" , creating:false, published: published},
        });
      }
    },

    changeCategories(event) {
      this.selectedCategory =
        event.target.options[event.target.options.selectedIndex].text;
    },
    select(id) {
      axios
        .get(
          process.env.VUE_APP_API+"api/staff/Article?CategoryId=" +
            id
        )
        .then((response) => {
          this.Article = response.data.result.result;
        });
    },
    async deleteData(id) {
      this.$confirm("Are you sure?", "Delete Post")
      .then(() => {
        axios
        .delete(process.env.VUE_APP_API+"api/staff/Article/" + id)
        this.$alert("success");
        this.onpageload();
      })
    },
  },
};
</script>

<style>
.home {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.vue-switch-lang {
  width: 30%;
}
.multiselect__option--selected {
  background-color: red;
}
.multiselect__option--highlight {
  background-color: green;
  background: green;
}
</style>